import { render, staticRenderFns } from "./DefaultFeesModal.vue?vue&type=template&id=84e3c08a&scoped=true&"
import script from "./DefaultFeesModal.vue?vue&type=script&lang=js&"
export * from "./DefaultFeesModal.vue?vue&type=script&lang=js&"
import style0 from "./DefaultFeesModal.vue?vue&type=style&index=0&id=84e3c08a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "84e3c08a",
  null
  
)

export default component.exports